<template>
    <div style="text-align: center">
      <div style="width: 90%; text-align: center; margin: 0 auto">
        <p class="title is-2" v-if="width < 1100"> Your certificate is ready! <br><br>  </p> 
        <Button @click="download" id="downloadButton" :style="{ fontSize: width < 1100 ? '20px' : '40px'}"> Download Certificate</Button>
        <br><br>
      </div>
      
      <canvas v-show="width > 1100" id="canvas" style="border: 1px solid grey" @click="download"></canvas>
      <br>
    </div>
  </template>
  
  <script>
  import api from "@/api";
  
  export default {
    components: {
    },
    data() {
      return {
        canvas: null,
        width: 1100,
        name: ""
      };
    },
    computed: {
      
    },
    methods: {
      doCanvas() {
  
      },
      download() {
        var link = document.createElement('a');
        link.href = this.canvas.toDataURL('image/jpeg');
        link.download = this.getUrlParam('name') + ' Certificate.png'
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      },
      getUrlParam: function (str) {
        var url = new URL(window.location.href)
        return url.searchParams.get(str.toLowerCase()) || ''
      },
    },
    mounted() {
      console.log("Mounted")
      this.width = window.innerWidth;
      var canvas = document.getElementById("canvas")
      this.canvas = canvas
      var ctx = canvas.getContext("2d");
      
      console.log(window.innerWidth)
      // var ratio = 850 / 1100
      // var w = Math.min(1100, window.innerWidth * 0.9)
      // canvas.width = w
      // var h = ratio * w
      // canvas.height = h
      // console.log(w, h)
      // canvas.width = 1000 // 1176
      // canvas.height = 707 // 1346
  
  
      var background = new Image();
      background.src = "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/whole-2.png";
      background.crossOrigin="anonymous"
      var img = background
      // Make sure the image is loaded first otherwise nothing will draw.
      background.onload = ()=>
      {
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        ctx = canvas.getContext("2d");
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, img.width,    img.height, 0, 0, canvas.width, canvas.height);
        // ctx.globalCompositeOperation='destination-under';
        // ctx.fillStyle = "#253f8e";
       
  
  
        ctx.font = "bold 80px Arial";
        ctx.textAlign = "left"
        ctx.fillStyle = "#057f8b"
  
        var course = this.getUrlParam("name") || ""
        var text = ctx.measureText(course)
        ctx.fillText(course, (canvas.width / 2) - (text.width / 2), (canvas.height / 2) - 560);
  
        ctx.font = "bold 60px Arial";
        var license = this.getUrlParam("license") || ""
        console.log(license)
        var text = ctx.measureText(license)
        ctx.fillText(license, (canvas.width / 2) +205, (canvas.height / 3) + 90)
  
        ctx.font = "bold 40px Arial";
        ctx.fillStyle = "#000000"
        const d = new Date();
        // Format: dd/mm/yy
        const pad = n => n.toString().padStart(2, '0');
        var date = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear().toString().slice(-2)}`;
        var text = ctx.measureText(date)
        ctx.fillText(date, (canvas.width / 2) +- text.width / 2 - 460, (canvas.height / 2) - 245);
      }
  
        // ctx.font = "bold 48px Arial";
        // var name = (this.getUrlParam("event_deliverymode") || "").toUpperCase()
        // var text = ctx.measureText(name)
        // console.log(text)
        // ctx.fillText(name, (canvas.width / 2) - (text.width/2)+ 580, (canvas.height / 2) - 40);
  
        // ctx.font = "bold 120px Arial";
        // ctx.fillStyle = "white"
        // var name = (this.getUrlParam("event_pdhours") || "").toUpperCase()
        // var text = ctx.measureText(name)
        // console.log(text)
        // ctx.fillText(name, (canvas.width / 2) - (text.width/2) + 495, (canvas.height - 315));
  
  
    },
  };
  </script>
  
  <style scoped lang="scss">
    canvas {
      background-size: 100% 100%;
      cursor: pointer;
      max-width: 80vw;
      max-height: 70vh;
    }
  
    #app {
      text-align: center
    }
  
    #downloadButton {
      background: #1e6eb0;
      color: white;
      width: auto;
      height: auto;
      padding: 15px 25px;
      border: 1px solid white;
      border-radius: 10px;
      font-size: 24px;
      cursor: pointer;
  
    }
  </style>